import { getAuthInstance } from "@/auth/authService";
import Router from "vue-router";
import Vue from 'vue'
import routes from './routes';
import store from '@/store/store'
import { canAccess } from '@/acl/roles';

Vue.use(Router)

const allRoutes = routes({ authGuard, guestGuard });

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: allRoutes,
});

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) => {
  // Check if we have the correct persona privilege for this route
  if (getAuthInstance().isAuthenticated
      && getAuthInstance().isTokenValid()
      && to.name !== 'dashboard'
      && to.name !== 'login'
      && to.name !== 'logout'
  ) {
    let hasAccess;

    if  (to.name.includes('personas')) {
      hasAccess = store.getters['personas/isSystem'];
    } else {
      hasAccess = await canAccess({name: to.name});
    }

    if (!hasAccess) {
      next('/dashboard');
    }
  }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.pageTitle);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.pageTitle;

  next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

/**
 * Redirect to login if guest.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function authGuard(routes) {
  return beforeEnter(routes, async (to, from, next) => {
    // Skip auth checks in router guard to prevent premature logout
    // Let the auth setup handle all authentication decisions
    return next()
  });
}

/**
 * Redirect home if authenticated.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function guestGuard(routes) {
  return beforeEnter(routes, async (to, from, next) => {
    if (store.getters['auth/accessToken']) {
      return next({ name: 'dashboard' });
    }
    next();
  });
}



/**
 * Apply beforeEnter guard to the routes.
 *
 * @param  {Array} routes
 * @param  {Function} beforeEnter
 * @return {Array}
 */
function beforeEnter(routes, beforeEnter) {
  return routes.map(route => ({ ...route, beforeEnter }));
}

export default router
